<template>
  <dl class="sidebar-stats-grid">
    <div v-for="item in items" :key="item.key" class="sidebar-stats-grid__item">
      <dt>{{ item.label }}</dt>
      <dd>{{ item.value }}</dd>
    </div>
  </dl>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue';
import type { StatItem } from '../helpers/sidebarStats';

export default defineComponent({
  name: 'SidebarStatsGrid',
  props: {
    items: {
      type: Array as PropType<StatItem[]>,
      default: () => [],
    },
  },
});
</script>

<style scoped>
.sidebar-stats-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 16px;
  margin: 0;
  padding: 14px;
}

.sidebar-stats-grid__item dt {
  margin-bottom: 2px;
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
}

.sidebar-stats-grid__item dd {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  color: #fff;
}
</style>
